import * as React from "react";

export type SimulatorPickLockValue = {
  /** When true, Add-to-simulator controls render disabled (demo / gated). */
  disabled: boolean;
  /** Tooltip when disabled. */
  reason: string;
};

const DEFAULT: SimulatorPickLockValue = {
  disabled: false,
  reason: "",
};

const SimulatorPickLockContext = React.createContext<SimulatorPickLockValue>(DEFAULT);

export function SimulatorPickLockProvider(props: {
  disabled: boolean;
  reason?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const value = React.useMemo(
    () => ({
      disabled: props.disabled,
      reason:
        props.reason ||
        "Simulator picks unlock with a Tessera subscription.",
    }),
    [props.disabled, props.reason]
  );
  return (
    <SimulatorPickLockContext.Provider value={value}>
      {props.children}
    </SimulatorPickLockContext.Provider>
  );
}

export function useSimulatorPickLock(): SimulatorPickLockValue {
  return React.useContext(SimulatorPickLockContext);
}
